/**
 * region for libraries*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

/**
 * region for styles*/
import { listLabelStyle } from './style/listLabelStyle';

class ListLabel extends Component {
    render() {
        const { classes } = this.props;
        return (
            <div className={classes.paddingDetails}>
                <Typography className={classes.subtitle2}
                    variant="body2"
                    display="block">
                    <strong>{this.props.title}</strong>
                </Typography>
                <div style={{ display: "block" }}>
                    {
                        this.props.items.map((item, index) =>
                            <Typography
                                variant="body2"
                                display="inline"
                                key={index}>
                                {index !== this.props.items.length - 1 ? item.DESCRIPTION + ', ' : item.DESCRIPTION + ' '}
                            </Typography>
                        )
                    }
                </div>
            </div>
        );
    }
}
ListLabel.propTypes = {
    classes: PropTypes.object.isRequired
};
export default withStyles(listLabelStyle)(ListLabel);





